import React from "react";
import { ChevronDown, Sparkles } from "lucide-react";

const LOGO_URL = "/logo-transparent.png";

const STATS = [
{ number: "6", label: "Self-Serve Bays" },
{ number: "24/7", label: "Every Day" },
{ number: "3", label: "Vacuums" }];


export default function Hero() {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen pt-16 overflow-hidden"
      style={{
        background:
        "linear-gradient(135deg, #f8fcff 0%, #e8f5fe 40%, #f0fdf8 100%)"
      }}>

      {/* Decorative floating bubbles */}
      <div className="absolute top-24 left-8 w-20 h-20 rounded-full bg-[#a8d8ea]/40 bubble-float pointer-events-none" />
      <div className="absolute top-48 right-16 w-14 h-14 rounded-full bg-[#a8d8ea]/30 bubble-float-delay-1 pointer-events-none" />
      <div className="absolute bottom-48 left-16 w-16 h-16 rounded-full bg-[#1a2744]/10 bubble-float-delay-2 pointer-events-none" />
      <div className="absolute bottom-32 right-32 w-10 h-10 rounded-full bg-[#a8d8ea]/60 bubble-float-delay-3 pointer-events-none" />
      <div className="absolute top-36 left-1/3 w-8 h-8 rounded-full bg-[#a8d8ea]/30 bubble-float-delay-1 pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 min-h-[calc(100vh-4rem)] flex items-center">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center w-full py-16">
          {/* Left: Content */}
          <div className="text-center lg:text-left fade-in-left">
            <div className="inline-flex items-center gap-2 bg-[#a8d8ea]/40 text-[#1a2744] rounded-full px-4 py-2 text-sm font-bold mb-6 border border-[#a8d8ea]/30">
              <Sparkles size={15} strokeWidth={2.5} className="text-[#1a2744]" />
              Self-Service Car Wash
            </div>

            <h1
              className="text-5xl sm:text-6xl font-bold text-[#1a2744] leading-tight mb-6"
              style={{ fontFamily: "Fredoka, sans-serif" }}
              data-testid="hero-heading">

              Wash Your Car.{" "}
              <span className="text-[#1a2744] relative">
                Your Way.
                <svg
                  className="absolute -bottom-2 left-0 w-full"
                  viewBox="0 0 200 12"
                  fill="none">

                  <path
                    d="M2 8 Q50 2 100 6 Q150 10 198 4"
                    stroke="#a8d8ea"
                    strokeWidth="5"
                    strokeLinecap="round"
                    fill="none" />

                </svg>
              </span>
            </h1>

            <p className="text-lg text-[#1a2744]/65 mb-8 leading-relaxed max-w-lg mx-auto lg:mx-0">
              Liv's Car Wash puts professional-grade equipment in your hands. Pull
              up to a bay, pick your wash mode, and get your car sparkling — on
              your schedule, at your own pace.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-12">
              <button
                onClick={() => scrollTo("#booking")}
                className="bg-[#a8d8ea] text-[#1a2744] rounded-full px-8 py-4 font-bold text-lg hover:-translate-y-1 hover:shadow-xl hover:bg-[#7fc8e0] transition-all duration-300"
                data-testid="hero-book-now-button">

                Find a Bay
              </button>
              <button
                onClick={() => scrollTo("#services")}
                className="bg-white text-[#1a2744] rounded-full px-8 py-4 font-bold text-lg border-2 border-[#a8d8ea] hover:-translate-y-1 hover:border-[#1a2744] hover:shadow-lg transition-all duration-300"
                data-testid="hero-see-services-button">

                See Packages
              </button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4 max-w-sm mx-auto lg:mx-0">
              {STATS.map((stat) =>
              <div
                key={stat.label}
                className="bg-white/70 rounded-2xl p-4 text-center border border-[#a8d8ea]/30 shadow-sm"
                data-testid={`hero-stat-${stat.label.toLowerCase().replace(/\s+/g, "-")}`}>

                  <div
                  className="text-2xl font-bold text-[#1a2744]"
                  style={{ fontFamily: "Fredoka, sans-serif" }}>

                    {stat.number}
                  </div>
                  <div className="text-xs text-[#1a2744]/60 font-semibold mt-1 leading-tight">
                    {stat.label}
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Right: Logo image */}
          <div className="flex justify-center lg:justify-end fade-in-right">
            <div className="relative w-full max-w-md">
              <div className="absolute inset-0 bg-[#a8d8ea]/25 rounded-full blur-3xl scale-110 pointer-events-none" />
              <img
                src={LOGO_URL}
                alt="Liv's Car Wash mascot"
                className="relative w-full h-auto drop-shadow-2xl"
                data-testid="hero-logo-image" />

            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <button
        onClick={() => scrollTo("#services")}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-[#1a2744]/40 hover:text-[#1a2744] transition-colors animate-bounce"
        data-testid="hero-scroll-indicator">

        <ChevronDown size={32} />
      </button>
    </section>);

}